module.exports = __webpack_public_path__ + "static/media/icon.608e4d9d.png";